import React, { useEffect, useState } from 'react'
import injectStyles from 'react-jss'
import moment from 'moment'
import { useDispatch } from 'react-redux'
import { AmbassadorSection } from '../../../../../../Components/City/Page/Ambassador/AmbassadorSection'
import LoadingIndicator from '../../../../../../Components/LoadingIndicator/LoadingIndicator'
import TrashCanIcon from '../../../../../../Assets/Images/icons/trashCan'
import ArrowBottomIcon from '../../../../../../Assets/Images/icons/arrowBottom'
import {
  hideReduxModal,
  showReduxModal,
} from '../../../../../../Reducers/UI/actions'
import GenericFlatButton from '../../../../../../Components/GenericFlatButton'
import TriangleAlert from '../../../../../../Assets/Images/icons/TriangleAlert'
import { MONTH_NAMES } from '../../../../../../constants'
import { getPayslipsByUserId, deletePayslip } from '../../gql'
import { styles } from './styles'

const DeleteConfirmModal = ({ onSubmit, onCancel, title, classes }) => {
  const [loading, setLoading] = useState(false)

  return (
    <div className={classes.modalContainer}>
      <div className={classes.modalIcon}>
        <TriangleAlert />
      </div>
      {title && <div className={classes.modalTitle}>{title}</div>}
      <div className={classes.modalButtons}>
        <GenericFlatButton
          type={'outline'}
          title={'Cancel'}
          onClick={() => onCancel()}
        />
        <GenericFlatButton
          type={'filled'}
          title={'Confirm'}
          onClick={async () => {
            setLoading(true)
            await onSubmit()
            setLoading(false)
          }}
          loading={loading}
        />
      </div>
    </div>
  )
}

const BaPayslipsSection = ({ ambassador, classes }) => {
  const [payslips, setPayslips] = useState([])
  const [isLoading, setIsLoading] = useState(true)
  const [isExpanded, setIsExpanded] = useState(false)
  const dispatch = useDispatch()

  const fetchPayslips = async () => {
    setIsLoading(true)
    try {
      const response = await getPayslipsByUserId({ userId: ambassador.id })
      const res = await response.json()
      const edges = res.data.brandAmbassador.payslips.edges || []
      setPayslips(edges.map(edge => edge.node))
    } catch (error) {
      console.error('Failed to fetch payslips:', error)
      setPayslips([])
    }
    setIsLoading(false)
  }

  useEffect(() => {
    if (ambassador.id) {
      fetchPayslips()
    }
  }, [ambassador.id])

  const onDelete = payslip => {
    dispatch(
      showReduxModal({
        children: (
          <DeleteConfirmModal
            classes={classes}
            title={`Are you sure you want to delete the payslip "${
              payslip.fileName
            }"?`}
            onSubmit={async () => {
              try {
                const response = await deletePayslip({ id: payslip.id })
                const res = await response.json()
                if (!res.data.deletePayslip.success) {
                  throw new Error('Delete failed')
                }
                dispatch(hideReduxModal())
                fetchPayslips()
              } catch (error) {
                dispatch(hideReduxModal())
                dispatch(
                  showReduxModal({
                    title: 'Error',
                    children: 'Failed to delete payslip. Please try again.',
                    hideCancel: true,
                    confirmLabel: 'OK',
                  }),
                )
              }
            }}
            onCancel={() => dispatch(hideReduxModal())}
          />
        ),
        hideConfirm: true,
        hideCancel: true,
        hideButtons: true,
        hideTitle: true,
      }),
    )
  }

  return (
    <AmbassadorSection>
      <div className={classes.wrapper}>
        <div
          className={classes.titleRow}
          onClick={() => setIsExpanded(!isExpanded)}
        >
          <div className={classes.title}>Payslips</div>
          <div
            className={classes.arrowButton}
            style={{
              transform: isExpanded ? 'rotate(180deg)' : 'rotate(0deg)',
            }}
          >
            <ArrowBottomIcon />
          </div>
        </div>
        {isExpanded && (
          <div>
            {isLoading ? (
              <LoadingIndicator />
            ) : payslips.length === 0 ? (
              <div className={classes.emptyState}>No payslips found</div>
            ) : (
              <table className={classes.table}>
                <thead>
                  <tr>
                    <th>File Name</th>
                    <th>Month / Year</th>
                    <th>Uploaded By</th>
                    <th>Upload Date</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {payslips.map(payslip => (
                    <tr key={payslip.id}>
                      <td>
                        <a
                          className={classes.link}
                          href={payslip.fileUrl}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {payslip.fileName}
                        </a>
                      </td>
                      <td>
                        {payslip.month >= 1 && payslip.month <= 12
                          ? MONTH_NAMES[payslip.month - 1]
                          : '-'}{' '}
                        {payslip.year}
                      </td>
                      <td>{payslip.uploadedByName || '-'}</td>
                      <td>
                        {payslip.createdAt
                          ? moment(Number(payslip.createdAt)).format(
                              'DD/MM/YYYY',
                            )
                          : '-'}
                      </td>
                      <td>
                        <button
                          className={classes.deleteButton}
                          onClick={() => onDelete(payslip)}
                          title="Delete payslip"
                        >
                          <TrashCanIcon width={16} height={16} />
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        )}
      </div>
    </AmbassadorSection>
  )
}

export default injectStyles(styles)(BaPayslipsSection)
